import Config from "../config";
import { applyMiddleware, combineReducers, createStore, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { loggerMiddleware } from "./logger";

import collectionReducer, {
  ICollectionState,
} from "./collection/collection.reducer";
import rootReducer, {IRootState} from './root/root.reducer';

export interface IAppState {
  collection: ICollectionState;
  root:IRootState;
}

const appReducer = combineReducers<IAppState>({
  collection: collectionReducer,
  root:rootReducer,
});

export let store: Store<IAppState>;

export const configureStore = () => {
  const middleware = Config.DEBUG
    ? composeWithDevTools(applyMiddleware(...loggerMiddleware))
    : undefined;
  store = createStore(appReducer, middleware);
};
